var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-card p-6 function-zero"},[_c('H3',{staticClass:"color"},[_vm._v("Bạn chưa đăng kí gói dịch vụ nào.")]),_c('vs-button',{staticClass:"ml-5",on:{"click":_vm.toUserPackage}},[_vm._v("Đăng ký gói dịch vụ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }